import { Box, Skeleton } from '@mui/material';

export default function FetchingFieldsLoader() {
  return (
    <>
      <Box>
        <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
        <Skeleton variant='rectangular' height={44} width='100%' sx={{ borderRadius: 1 }} />
      </Box>
      <Box mt={3}>
        <Skeleton variant='text' width={140} height={20} sx={{ mb: 1 }} />
        <Skeleton variant='rectangular' height={44} width='100%' sx={{ borderRadius: 1 }} />
      </Box>
    </>
  );
}
